import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const postTeamUserAuth = unaryRpc({
  name: "postTeamUserAuth",
  input: z.object({ teamId: z.string(), userId: z.string() }),
  output: z.object({ authToken: z.string(), user: z.unknown() }),
});
